var React = require('react');

function JetCharters (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M1 26C4.947 9.618 25.9 15.456 31 3c1.984 9.908-.665 16.717-12 17m10-3c2 6.5-3 11.5-14 9.971"})));
}

JetCharters.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = JetCharters;

JetCharters.default = JetCharters;
